import { useLayoutEffect, useState } from 'react';

export const useResizeTabBar = (wrapper: React.RefObject<HTMLDivElement>) => {
  const [wrapperWidth, setWrapperWidth] = useState<number>(0);

  useLayoutEffect(() => {
    let timeoutId: number | undefined = undefined;

    const handleResize = () => {
      clearTimeout(timeoutId);

      timeoutId = window.setTimeout(() => {
        if (!wrapper.current) return;

        setWrapperWidth(wrapper.current.offsetWidth);
      }, 150);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return wrapperWidth;
};
